import * as type from '@/constant/redux-const';

export const setLoader = (flag:boolean) => ({
  type: type.SET_LOADER,
  flag,
});

export default {
  setLoader,
};
